import { motion } from "motion/react";
import Header from "../../../components/feature/Header";
import Footer from "../../../components/feature/Footer";
import WhatsAppFloating from "../../../components/feature/WhatsAppFloating";
import CookieBanner from "../../../components/feature/CookieBanner";
import QuoteFormSection from "../../home/components/QuoteFormSection";
import SEO from "@/components/feature/SEO";

const steps = [
  { num: "1", title: "Visita técnica + medición precisa", desc: "Acudimos a tu domicilio gratis, medimos con precisión milimétrica y analizamos la fachada. Sin coste ni compromiso." },
  { num: "2", title: "Diseño 3D + presupuesto detallado", desc: "Te presentamos un diseño en 3D de cómo quedará tu toldo. Presupuesto claro, por escrito, sin sorpresas." },
  { num: "3", title: "Pedido y fabricación a medida", desc: "Fabricamos tu toldo exacto a las medidas de tu espacio. Plazo: 15-20 días hábiles para lonas estándar." },
  { num: "4", title: "Instalación profesional", desc: "Nuestro equipo de técnicos certificados monta todo en una sola jornada. Limpio, rápido y sin obras innecesarias." },
  { num: "5", title: "Entrega + tutorial uso + garantía", desc: "Te explicamos cómo usar el mando, programar horarios y conectar con apps. Entregamos garantía oficial por escrito." },
];

const incluye = [
  "Visita técnica + medición",
  "Presupuesto detallado por escrito",
  "Fabricación a medida exacta",
  "Anclajes + conexión eléctrica (motorizados)",
  "Pruebas y entrega operativa",
  "Tutorial uso + mantenimiento",
];

const tiempos = [
  { tipo: "Toldo balcón", tiempo: "1-2 horas", emoji: "🏠" },
  { tipo: "Toldo cofre motorizado", tiempo: "3-4 horas", emoji: "📦" },
  { tipo: "Pérgola compleja", tiempo: "1-2 días", emoji: "🏗️" },
];

const garantias = [
  { item: "Estructura metálica", años: "5 años", emoji: "🛠️" },
  { item: "Motor Somfy", años: "5 años", emoji: "⚡" },
  { item: "Lona técnica", años: "3 años", emoji: "🌞" },
  { item: "Mano de obra", años: "2 años", emoji: "🔧" },
];

const faqs = [
  {
    q: "¿Necesito permiso del ayuntamiento?",
    a: "Para toldos de balcón o terraza residencial, generalmente no es necesario una licencia de obra mayor. Solo requieres una declaración responsable o comunicación previa en el Ayuntamiento de Málaga si el toldo sobresale de la fachada más de ciertos metros. Te asesoramos gratuitamente según tu caso concreto.",
  },
  {
    q: "¿Qué pasa si vivo en comunidad de vecinos?",
    a: "Según la Ley de Propiedad Horizontal, los elementos exteriores visibles deben respetar la estética del edificio. Generalmente necesitarás la aprobación en junta de vecinos. Te ayudamos a preparar toda la documentación técnica: plano, fotos del toldo propuesto, especificaciones y informe de instalador. Presentamos nosotros el expediente si lo prefieres.",
  },
  {
    q: "¿Hacéis el cableado eléctrico?",
    a: "Sí, nuestros técnicos están habilitados para realizar la conexión eléctrica del motor a la instalación existente de tu vivienda. Si no hay punto de luz cercano, instalamos un conector seguro con tubo protector hasta el punto más cercano. Todo incluido en el precio de instalación.",
  },
  {
    q: "¿Trabajáis en alturas altas?",
    a: "Totalmente. Instalamos toldos desde planta baja hasta áticos en altura. Contamos con técnicos certificados en trabajos en altura, plataformas elevadoras y andamios cuando es necesario. La seguridad de nuestros técnicos y de tu vivienda es prioridad.",
  },
  {
    q: "¿Cuánto tiempo tarda desde el presupuesto?",
    a: "Desde que aceptas el presupuesto hasta la instalación: toldos estándar 15-20 días (fabricación + entrega + montaje). Toldos premium o lonas especiales pueden tardar 3-4 semanas. Pérgolas complejas: 4-6 semanas. Si tienes urgencia, pregúntanos: a veces podemos adelantar fechas.",
  },
];

export default function InstalacionToldos() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Instalación Toldos Málaga | Técnicos Certificados"
        description="Instalamos toldos a medida en Málaga. Visita técnica gratis, diseño 3D, montaje profesional. Garantía 5 años."
        canonical="/toldos/instalacion-toldos/"
        breadcrumbs={[{ name: "Inicio", path: "/" }, { name: "Toldos", path: "/toldos" }, { name: "Instalación toldos" }]}
      />
      <Header />
      <main>
        {/* HERO */}
        <section className="bg-white pt-24 md:pt-[72px]">
          <div className="max-w-container mx-auto px-4 md:px-6 py-12 md:py-24">
            <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
              <div className="w-full lg:w-[60%] flex flex-col gap-6">
                <div className="inline-flex items-center gap-2 bg-accent text-text-primary font-body font-semibold text-sm px-4 py-2 rounded-pill w-fit">
                  <span>⚡</span> Técnicos certificados
                </div>
                <h1 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-[56px] leading-[1.1] text-text-primary">
                  Instalación de Toldos en Málaga
                </h1>
                <p className="font-body text-lg md:text-xl text-text-secondary leading-relaxed max-w-xl">
                  Servicio profesional con técnicos certificados. Medición, diseño y montaje con garantía.
                </p>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                  <a
                    href="tel:+34951120770"
                    className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-body font-bold text-lg md:text-xl px-8 py-4 rounded-pill transition-colors whitespace-nowrap"
                  >
                    <span>📞</span> 951 12 07 70
                  </a>
                  <a
                    href="#presupuesto"
                    className="inline-flex items-center gap-2 border-2 border-secondary text-secondary hover:bg-secondary hover:text-white font-body font-semibold text-base px-6 py-3.5 rounded-pill transition-colors whitespace-nowrap"
                  >
                    Pedir presupuesto
                  </a>
                </div>
                <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-2">
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> +10 años · desde 2015</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Técnicos certificados</span>
                  <span className="flex items-center gap-1.5 font-body font-medium text-sm text-text-secondary"><span className="text-green-600">✓</span> Garantía 5 años</span>
                </div>
              </div>
              <div className="w-full lg:w-[40%] relative">
                <div className="relative rounded-3xl overflow-hidden lg:rotate-1 shadow-xl">
                  <div className="absolute inset-0 bg-blue-900/35 z-10 pointer-events-none"></div>
                  <img
                    src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&q=80&auto=format&fit=crop"
                    alt="Instalación profesional de toldos en Málaga"
                    className="w-full h-auto object-cover aspect-[4/3]"
                    loading="eager"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* PROCESO 5 STEPS */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Nuestro proceso de instalación</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
              <p className="font-body text-lg text-text-secondary max-w-2xl mx-auto mt-4">
                Desde la primera visita hasta la entrega final, te acompañamos en cada paso.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
              {steps.map((s, i) => (
                <motion.div
                  key={s.num}
                  className="relative text-center bg-white rounded-[20px] p-6 shadow-sm"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="w-14 h-14 bg-primary text-white rounded-full flex items-center justify-center font-heading font-extrabold text-xl mx-auto mb-4">
                    {s.num}
                  </div>
                  <h3 className="font-heading font-bold text-base text-text-primary mb-2">{s.title}</h3>
                  <p className="font-body text-xs text-text-secondary leading-relaxed">{s.desc}</p>
                  {i < steps.length - 1 && (
                    <div className="hidden lg:block absolute top-7 left-[calc(50%+1.75rem)] right-[-50%] h-0.5 bg-border"></div>
                  )}
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* ¿QUÉ INCLUYE? */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-start">
              <div className="w-full lg:w-1/2">
                <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">¿Qué incluye la instalación?</h2>
                <div className="w-10 h-1 bg-primary rounded-full mb-6"></div>
                <p className="font-body text-lg text-text-secondary leading-relaxed mb-8">
                  Todo incluido en el precio. No cobramos extra por mediciones, desplazamientos ni conexiones eléctricas básicas.
                </p>
                <div className="flex flex-col gap-3">
                  {incluye.map((item, i) => (
                    <motion.div
                      key={i}
                      className="flex items-center gap-4 bg-surface-alt rounded-xl px-5 py-4"
                      initial={{ opacity: 0, x: -15 }}
                      whileInView={{ opacity: 1, x: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.4, delay: i * 0.08 }}
                    >
                      <span className="flex items-center justify-center w-8 h-8 bg-primary/10 text-primary rounded-full shrink-0 font-bold text-sm">✓</span>
                      <span className="font-body text-base text-text-primary">{item}</span>
                    </motion.div>
                  ))}
                </div>
              </div>
              <div className="w-full lg:w-1/2">
                <img
                  src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&q=80&auto=format&fit=crop"
                  alt="Técnico instalando toldo en Málaga"
                  className="w-full rounded-3xl object-cover aspect-[7/5] shadow-xl"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </section>

        {/* TIEMPO DE INSTALACIÓN */}
        <section className="bg-surface-alt py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Tiempo de instalación</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-4xl mx-auto">
              {tiempos.map((t, i) => (
                <motion.div
                  key={t.tipo}
                  className="bg-white rounded-[20px] p-8 text-center shadow-sm hover:shadow-md transition-shadow"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="text-3xl mb-3">{t.emoji}</div>
                  <h3 className="font-heading font-bold text-lg text-text-primary mb-2">{t.tipo}</h3>
                  <p className="font-heading font-extrabold text-3xl text-primary">{t.tiempo}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* GARANTÍA */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary mb-4">Garantía completa</h2>
              <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
              <p className="font-body text-lg text-text-secondary max-w-2xl mx-auto mt-4">
                Todo por escrito. Sin letra pequeña. Sin sorpresas.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-4xl mx-auto">
              {garantias.map((g, i) => (
                <motion.div
                  key={g.item}
                  className="bg-surface-alt rounded-[20px] p-8 text-center shadow-sm hover:shadow-md transition-shadow border-t-[6px] border-primary"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                >
                  <div className="text-3xl mb-3">{g.emoji}</div>
                  <h3 className="font-heading font-bold text-base text-text-primary mb-1">{g.item}</h3>
                  <p className="font-heading font-extrabold text-2xl text-primary">{g.años}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="bg-primary py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-white mb-4">¿Listo para instalar tu toldo?</h2>
            <p className="font-body text-lg text-white/90 max-w-xl mx-auto mb-8">
              Visita técnica gratis, presupuesto en 24h y instalación profesional. Sin compromiso.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="tel:+34951120770"
                className="inline-flex items-center gap-2 bg-white hover:bg-slate-100 text-primary font-body font-bold text-lg px-8 py-4 rounded-pill transition-colors whitespace-nowrap"
              >
                <span>📞</span> 951 12 07 70
              </a>
              <a
                href="#presupuesto"
                className="inline-flex items-center gap-2 border-2 border-white text-white hover:bg-white hover:text-primary font-body font-semibold text-base px-6 py-3.5 rounded-pill transition-colors whitespace-nowrap"
              >
                Pedir presupuesto online
              </a>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="bg-white py-16 md:py-24">
          <div className="max-w-container mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto" itemScope itemType="https://schema.org/FAQPage">
              <h2 className="font-heading font-bold text-3xl md:text-4xl text-text-primary text-center mb-12">Preguntas frecuentes sobre instalación</h2>
              <div className="flex flex-col gap-4">
                {faqs.map((f, i) => (
                  <motion.div
                    key={i}
                    className="bg-surface-alt rounded-2xl p-6"
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.4, delay: i * 0.08 }}
                    itemScope
                    itemProp="mainEntity"
                    itemType="https://schema.org/Question"
                  >
                    <h3 className="font-heading font-bold text-lg text-text-primary mb-2" itemProp="name">{f.q}</h3>
                    <div itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                      <p className="font-body text-sm text-text-secondary leading-relaxed" itemProp="text">{f.a}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* FORM */}
        <div id="presupuesto">
          <QuoteFormSection />
        </div>
      </main>
      <Footer />
      <WhatsAppFloating />
      <CookieBanner />
    </div>
  );
}